module.exports = "//static.hsappstatic.net/web-interactives-components/static-1.9821/img/meetingPopupPreview.png"